
export interface IDocumentSpec {
  dpi: number;
  height: number;
  width: number;
}

export interface ILabelElement {
  id: string;
  position: ILabelElementPosition;
  properties: {[key: string] :Object};
  renderIf: string;
  rotation: number;
  size: ILabelElementSize;
  type: LabelElementType;
}

export interface ILabelElementPosition {
  x: number;
  y: number;
}

export interface ILabelElementSize {
  x: number;
  y: number;
}

export interface ILabelInput {
  beanList: {[key: string] :Object}[] | any[];
  format: LabelFormat;
  multiplierExpression: string;
  params: {[key: string] :Object} | {[key: string] :any};
  pdfGridPageSize: string;
  pdfGridSpec: string;
  rotateLabel90: boolean;
  srcType: LabelInputType;
  xlsxFile: string;
}

export interface ILabelSpec {
  defaultInput: ILabelInput;
  document: IDocumentSpec;
  elements: ILabelElement[];
  sqlQuery: string;
}

export type LabelElementType = 'TEXT' | 'BARCODE' | 'QRCODE' | 'IMAGE' | 'RECTANGLE' | 'CIRCLE';
export const LabelElementTypeValues: LabelElementType[] = ['TEXT' , 'BARCODE' , 'QRCODE' , 'IMAGE' , 'RECTANGLE' , 'CIRCLE'];

export type LabelFormat = 'PDF' | 'PDF_GRID' | 'PNG' | 'ZPL' | 'TSPL';
export const LabelFormatValues: LabelFormat[] = ['PDF' , 'PDF_GRID' , 'PNG' , 'ZPL' , 'TSPL'];

export type LabelInputType = 'EMPTY_ROW' | 'SQL' | 'XLSX' | 'BEAN_LIST';
export const LabelInputTypeValues: LabelInputType[] = ['EMPTY_ROW' , 'SQL' , 'XLSX' , 'BEAN_LIST'];

